// Bootstrap JS
// @devnote comment this line if you plan to
// use the CDN version of boostrap js
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

// Vue, Vue components
import Vue from 'vue';
window.Vue = Vue;

import postsLoop from './vue/posts-loop.vue';
import postsLoopItem from './vue/posts-loop-item.vue';
import affiliatesSearch from './vue/affiliates-search.vue';

Vue.component('posts-loop', postsLoop);
Vue.component('posts-loop-item', postsLoopItem);
Vue.component('affiliates-search', affiliatesSearch);

const appIds = ['posts-app', 'affiliates-app'];
appIds.forEach((appId) => {
	const appElement = document.getElementById(appId);
	if (appElement) {
		window[appId] = new Vue({ el: appElement });
	}
});

// App
import * as webfontloader from 'webfontloader';
import { watchNavbarCollapse } from './lib/navbar';
import { watchScroll } from './lib/scroll';
import { silenceModalsOnDismiss } from './lib/video';

/**
 * Benchmarking
 */
const timeStart = window.performance.now();

/**
 * Configure fonts for this project
 */
const webfonts = {
	google: {
		families: ['Inter:300,400,500,700,800,900'],
	},
};

document.addEventListener('DOMContentLoaded', () => {
	/**
	 * Load Webfonts
	 */
	webfontloader.load(webfonts);

	// Do stuff...
	watchScroll();
	silenceModalsOnDismiss();
	watchNavbarCollapse();

	/**
	 * Benchmarking reporting
	 */
	const timeEnd = window.performance.now();
	console.info(
		`Execution time: ${timeEnd - timeStart}ms after DOMContentLoaded.`
	);
});
